import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { App } from './App';
import { ApiError, initTenantFromUrl } from './lib/api';
import { registerServiceWorker } from './lib/app-install';
import { AuthProvider, ME_KEY } from './lib/auth';
import { ThemeProvider, useTheme } from './lib/theme';
import './index.css';

initTenantFromUrl();
registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

// Abgelaufene Session: zurück zur Anmeldung.
queryClient.getQueryCache().subscribe((event) => {
  const error = event.query.state.error;
  if (event.type === 'updated' && error instanceof ApiError && error.status === 401 && event.query.queryKey[0] !== ME_KEY[0]) {
    queryClient.setQueryData(ME_KEY, null);
  }
});

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} richColors position="top-right" closeButton />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
          <ThemedToaster />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
